import React, { Component } from 'react';
import Hypher from 'hypher';
import HyphenationMapNL from 'hyphenation.nl';
import HyphenationMapEN from 'hyphenation.en-gb';
import LanguageTypes from './../../../../constants/LanguageTypes';
import Developability from './../../../../components/Developability';
import style from './style/scorewithdevelopability.scss';

export default class ScoreWithDevelopability extends Component {
    constructor(props) {
        super(props);

        this.hyphenateText = this.hyphenateText.bind(this);
    }

    hyphenateText(val) {
        const { languageId } = this.props;

        if (!val) {
            return '';
        }

        if (!this.props.languageId) {
            return val;
        }

        let participantLanguage, hyphenationMap;

        if (languageId) {
            participantLanguage = languageId.replace('-', '_');
        }

        // determine the right hyphenation map with a default to english
        switch (participantLanguage) {
            case LanguageTypes.NL:
                hyphenationMap = HyphenationMapNL;
                break;

            case LanguageTypes.EN:
            default:
                hyphenationMap = HyphenationMapEN;
                break;
        }

        const hypher = new Hypher(hyphenationMap);

        return val.split(' ').map(splitVal => hypher.hyphenate(splitVal).join('&shy;')).join(' ');
    }

    isInteger(num) {
        return num % 1 === 0;
    }

    showScoreWithDevelopability(developabilityLabel, developabilityScore, developabilityDefinition, scoreOutput) {

        // developabilityDefinition present, dont show label (or score) since label and definition are already present above the scorebar section
        if (developabilityDefinition) {
            return null;
        }

        let developability = null;

        // show developability indicator if there is at least a score to render (label is optional, for tooltip)
        if (developabilityScore) {
            developability = <Developability
                developabilityLabel={ developabilityLabel }
                developabilityScore={ developabilityScore }
                classes={{
                    root: style.developability
                }}
            />;

            return <section
                className={`${style.titleWrapper} ${this.props.classes.titleWrapper}`}>{ developability } { scoreOutput }</section>
        }

        // just output the score or value without the developability wrapper
        return scoreOutput;
    }

    render() {
        const {
            classes,
            scoreName,
            scoreValueVisible,
            displayScore,
            developabilityScore,
            developabilityLabel,
            developabilityDefinition,
            scoreValue
        } = this.props;

        let scoreOutput = null;

        // if the actual score value should be displayed and it was provided:
        if (scoreValueVisible && scoreValue > 0) {
            scoreOutput = <h3 className={`${style.scoreValue} ${classes.scoreValue}`}>
                {
                    // when score comes in as float, round to 1 decimal. otherwise do not round and display as integer
                    this.isInteger(scoreValue)
                        ? scoreValue
                        : parseFloat(scoreValue).toFixed(1)
                }
            </h3>;
        }

        // if a score name or a displayScore was provided, output the score name instead of the value:
        if (scoreName || displayScore) {
            scoreOutput = <h3 className={`${style.scoreName} ${classes.scoreName}`} dangerouslySetInnerHTML={{ __html: this.hyphenateText(scoreName) }}/>;
        }

        return (
            <React.Fragment>
                { this.showScoreWithDevelopability(developabilityLabel, developabilityScore, developabilityDefinition, scoreOutput) }
            </React.Fragment>
        );
    }
}
